import { get, isNil, isUndefined } from '@poseidon-city/utils';

type TConfiguration = {
  [key: string]: unknown;
};

type TGlobal = {
  configuration: TConfiguration | undefined;
};

type TConfig = {
  get<TPValue>(key: string): TPValue;
  get<TPValue>(key: string, defaultValue: TPValue): TPValue;
};

const global: TGlobal = window as unknown as TGlobal;

function Config(): TConfig {
  if (isNil(global.configuration)) {
    throw new Error('Configuration not found');
  }

  return {
    get<TPValue>(key: string, defaultValue?: TPValue): TPValue {
      let value = get(global.configuration, key);

      value = value ?? defaultValue;

      if (isUndefined(defaultValue) && isNil(value)) {
        throw new Error(`Parameter with key '${key}' not found`);
      }

      return value as TPValue;
    },
  };
}

export const config: TConfig = Config();
